import React from 'react';
import {connect} from "react-redux";
import {setSQFTSystemDeleteMessage} from "../../../../actions/sqftMenuFunctions";
import workspace from "../../components/canvas/core/workspace";
import {updateSQFTCalculations} from "../../../../actions/sqftFunctions";

const SqftSystemDeleteMessage = (props) => {
  const {systemDeleteMessage, setSQFTSystemDeleteMessage, updateCalculations, updateSQFTCalculations} = props;
  const handleDeleteClick = () => {
    window.lineInputFocused = false;
    workspace.removeShape(systemDeleteMessage.shape);
    setSQFTSystemDeleteMessage({isOpened: false, shape: null});
    updateSQFTCalculations(updateCalculations + 1);
  };

  const handleCancelClick = () => {
    window.lineInputFocused = false;
    setSQFTSystemDeleteMessage({isOpened: false, shape: null});
  };

  return (
    <div className={"message-box-overlay " + (systemDeleteMessage.isOpened ? "" : "hidden")} >
      <div className="message-window-base">
        <div className="message-system-message-title" data-text="sqft.popup.title">System Message</div>
        <div className="message-blue-lable"/>
        <div className="message-system-text message-system-text-blue">
          <span data-text="sqft.popup.deleteQuestion1">Are you sure you want to delete this countertop?</span><br/>
          <span data-text="sqft.popup.deleteQuestion2">All edges, corners, backsplash & walls on this top will be removed.</span>
        </div>
        <div className="message-box-buttons message-box-buttons--modal">
          <button className="ui-button10 ui-button10--blue meta-buttons-confirm-nav--no" onClick={handleCancelClick}>
            <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonCancel">Cancel</span>
          </button>
          <button className="ui-button10 ui-button10--red meta-buttons-confirm-nav--yes" onClick={handleDeleteClick}>
            <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonDelete">Delete</span>
          </button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  systemDeleteMessage: store.sqftMenuState.systemDeleteMessage,
  updateCalculations: store.sqftState.updateCalculations,
});

const mapDispatchToProps = {
  setSQFTSystemDeleteMessage,
  updateSQFTCalculations,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftSystemDeleteMessage);
